<template>
    <div id="techhome">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="outercircle">
            <div class="homeName">
                Planning
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="plusButton()" class="btnBack">
                <font-awesome-icon icon="plus" />
            </button>
            {{title}}
        </h1>
        <div id='calendar'>
            <FullCalendar   class="calendar"
                            ref="fullcalendar"
                            @dateClick="handleDateClick"
                            @eventClick="eventClick"
                            :themeSystem='themeCal'
                            schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                            timeZone="Europe/Paris" 
                            defaultView="timeGridDay" 
                            resourceLabelText="Techniciens"
                            locale='fr'
                            minTime='05:00:00'
                            maxTime='20:00:00'
                            :weekends="false"
                            :allDaySlot="false"
                            :slotDuration='slotDuration()'
                            :aspectRatio="calRatio"
                            :buttonText="btnTxt"
                            :selectable="calSelect"
                            :nowIndicator="calNow"
                            :editable="calEdit"
                            :plugins="calendarPlugins"
                            :header="calHeader"
                            :resources="calResources"
                            :events="calEvents"
                            :datesRender="datesRender"
            />
       </div>
            
        <modal height="250px" name="planningdetails">
            <div class="modalDiv">
                <div class="txtDiv">
                    <span class="modalTxt"><b>Intervention :</b><br>{{ModalType}}</span>
                </div>    
                <div class="txtDiv">
                    <span class="modalTxt"><b>Adresse :</b><br>{{ModalAddress}}</span>
                </div>    
                <div class="txtDiv">
                    <span class="modalTxt"><b>Notes :</b><br>{{ModalNote}}</span>
                </div>    
                <button v-if="isModalButton" class="docBtn3" type="button" v-on:click="closeModal">Démarrer</button>   
            </div>    
        </modal>
        <modal height="250px" width="400px" name="validationModal">
            <div class="modalDiv">  
                <div class="txtDiv">
                    <img class="modalTxt" :src="imgValidation"/>
                </div>  
                <div class="txtDiv">
                    <span class="modalTxt">{{validationPhrase}}</span>
                </div>    
                <button class="docBtn3" type="button" v-on:click="okButton()">OK</button>   
            </div>    
        </modal>
        <modal height="80%" name="newActivity">
            <div class="modalDiv">
                <h2>Nouvelle Activité</h2>
                <b class="textLen">Type de l'activité :</b>
                <select class="inputTxt select" v-model="planning.activityType">
                    <option class="inputTxt" :value="'divers'" selected>
                        Divers
                    </option>
                    <option class="inputTxt" :value="'pause'">
                        Pause
                    </option>
                </select>
                <div class="textline">
                    <b class="textLen">Date de début :</b>
                    <datepicker @selected="changeHandler()" input-class="inputDate" class="wrapperDate" :language="fr" v-model="pick.start.date"></datepicker>
                </div>
                <div class="textline">
                    <b class="textLen">Heure de début :</b>
                    <vue-timepicker @change="changeHandler()" class="wrapperDate" :minute-interval="5" v-model="pick.start.hour" hide-clear-button></vue-timepicker>
                </div>
                <div class="textline">
                    <b class="textLen">Date de fin :</b>
                    <datepicker @selected="changeHandler()" input-class="inputDate" class="wrapperDate" :language="fr" v-model="pick.end.date"></datepicker>
                </div>
                <div class="textline">
                    <b class="textLen">Heure de fin :</b>
                    <vue-timepicker @change="changeHandler()" class="wrapperDate" :minute-interval="5" v-model="pick.end.hour" hide-clear-button></vue-timepicker>
                </div>
                <div class="textline">
                    <b class="textLen high">Bloc notes :</b>
                    <textarea rows="3" class="inputTxt area" type="text" v-model="planning.note" ></textarea>
                </div>
                <button class="docBtn3" type="button" v-on:click="validateButton">Valider</button>
            </div>    
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import Datepicker from 'vuejs-datepicker';
    import {fr} from 'vuejs-datepicker/dist/locale'
    import VueTimepicker from 'vue2-timepicker'
    import FullCalendar from '@fullcalendar/vue'
    import interactionPlugin from '@fullcalendar/interaction'
    import timegridPlugin from '@fullcalendar/timegrid'
    import daygridPlugin from '@fullcalendar/daygrid'
    import bootstrapPlugin from '@fullcalendar/bootstrap'
    import luxonPlugin from '@fullcalendar/luxon'
    import momentPlugin from '@fullcalendar/moment'
    import momentTZPlugin from '@fullcalendar/moment-timezone'

    export default {
        name: 'Techhome',
        components: {
            Datepicker,
            VueTimepicker,
            FullCalendar
        },
        data() {
            return {
                btnTxt:{
                  today:    "Revenir à Aujourd'hui",
                  month:    'mois',
                  week:     'semaine',
                  day:      'jour',
                  list:     'liste'
                },
                pick:{
                    start:{
                        date: new Date(2016, 9,  16),
                        hour: {
                                HH: "10",
                                mm: "05",
                                ss: "00"
                            },
                    },
                    end:{
                        date: new Date(2016, 9,  16),
                        hour: {
                                HH: "10",
                                mm: "05",
                                ss: "00"
                            },
                    }
                },
                calendarPlugins: [
                                    interactionPlugin,
                                    timegridPlugin,
                                    daygridPlugin,
                                    bootstrapPlugin,
                                    luxonPlugin,
                                    momentPlugin,
                                    momentTZPlugin
                                 ],
                calRatio:1.55,
                calEvents:[],
                calResources:[],
                calEdit:false,
                calSelect:true,
                calNow:true,
                color2:["DarkOrange","MediumAquaMarine","MediumSpringGreen","SlateBlue","MediumTurquoise","Chocolate","PaleVioletRed","SaddleBrown","Orchid","DarkGreen","Orange","Plum","ForestGreen","OliveDrab","DarkSalmon","Teal","Cyan","DarkOrchid","LawnGreen","RebeccaPurple","GreenYellow","IndianRed","HotPink","Turquoise","DarkCyan","DarkKhaki","DarkMagenta","Aquamarine","DarkViolet","CornflowerBlue","DarkOliveGreen","DeepSkyBlue","BlueViolet","Thistle","Linen","Gold","Bisque","DodgerBlue","Purple","RosyBrown","Red","Magenta","YellowGreen","LemonChiffon","Chartreuse","Wheat","Gainsboro","MediumVioletRed","LimeGreen","BurlyWood","LavenderBlush","CadetBlue","Peru","SeaGreen","MistyRose","DarkBlue","DarkTurquoise","Brown","DarkRed","DarkSeaGreen","Violet","Maroon","Yellow","Crimson","Pink","SpringGreen","MediumOrchid","Fuchsia","SteelBlue","DarkGoldenRod","GoldenRod","RoyalBlue","PeachPuff","MediumPurple","PaleGoldenRod","Olive","MediumSlateBlue","Khaki","Indigo","AntiqueWhite","Blue","SkyBlue","DeepPink","Lavender","Sienna","Silver","PaleTurquoise","OrangeRed","Moccasin","Coral","FireBrick","Salmon","MediumBlue","MediumSeaGreen","SandyBrown","Tomato","Aqua","Lime","Green","Tan","PaleGreen","PowderBlue"],
                color3:["#339933","#99334d","#33ff99","#993366","#669933","#ccff33","#33ffcc","#4d9933","#ffcc33","#336699","#9933ff","#809933","#3333ff","#4d3399","#ffff33","#33ff33","#994d33","#334d99","#803399","#cc33ff","#3399ff","#6633ff","#ff3366","#33994d","#339980","#ff3333","#ff9933","#33ffff","#3366ff","#99ff33","#663399","#33ccff","#ff6633","#996633","#ff3399","#ff3333","#999933","#338099","#993333","#66ff33","#ff33ff","#33ff66","#333399","#998033","#993333","#993380","#ff33cc","#339999","#339966","#993399"],
                color5:["#99ff33","#ff9933","#334d99","#ff3399","#339999","#994d33","#663399","#ff3333","#ffcc33","#33ff99","#4d3399","#4d9933","#33ff33","#339933","#669933","#ff33ff","#6633ff","#ff33cc","#339966","#99334d","#ff3333","#9933ff","#33ffcc","#ff3366","#993380","#993333","#3399ff","#66ff33","#33994d","#809933","#333399","#996633","#998033","#33ffff","#3333ff","#339980","#ff6633","#993399","#33ff66","#993333","#ccff33","#999933","#993366","#cc33ff","#803399","#33ccff","#338099","#3366ff","#ffff33","#336699"],
                color4:["Red","Yellow","Cyan","Blue","Magenta","Green","Pink","Purple","Salmon","Orange","Lime","Olive","SaddleBrown","Maroon","RebeccaPurple","OrangeRed","Gold","DarkKhaki","RosyBrown","DarkGoldenRod","Peru","Tan","Indigo","Teal","Gray","Black"],
                color:["Gold","Orange","Lime","DodgerBlue","Indigo","Red","Magenta","RosyBrown","Pink","DarkKhaki","Cyan","DarkGoldenRod","Purple","Yellow","RebeccaPurple","Salmon","Green","Teal","OrangeRed","Blue","SaddleBrown","Maroon","Tan","Peru","Olive","Gray","Black"],
                themeCal:'Materia',
                calHeader: {
                          left: 'dayGridMonth,   timeGridWeek,   timeGridDay',
                          center: 'title',
                          right: "prev,next, today"
                        },
                plannings : [],
                activeStart: new Date()/1000 |0,
                activeEnd: new Date()/1000 |0,
                ModalType: "Type d'intervention inconnue",
                ModalAddress: "Adresse de l'intervention inconnue",
                ModalNote: "Notes de l'intervention vide",
                isModalButton:true,
                validationPhrase: "La nouvelle activitée a été correctement enregistré",
                imgValidation: "/assets/right.png",
                Name:"Client",
                id:"",
                title: "",
                fr:fr,
                intervention:{},
                inquiry:{},
                building:{},
                user: {},
                planning:{
                    user:             {idWeweb: ""},
                    activityType:     "divers",
                    startTimestamp:   1558706400,
                    endTimestamp:     1558710000,
                    isMain:           true,
                    isEstimated:      false,
                    isRemote:         false,
                    note:             "",
                    addressStr:       ''
                }
            };
        },
        methods:{
            openModalActivity(){
                this.$modal.show('newActivity');
            },
            closeModalActivity(){
                this.$modal.hide('newActivity');
            },
            openModalValidation(){
                this.$modal.show('validationModal');
            },
            closeModalValidation(){
                this.$modal.hide('validationModal');
            },
            openModal(){
                this.getInquiry(this.intervention._id);
                this.$modal.show('planningdetails');
            },
            closeModal(){
                this.$modal.hide('planningdetails');
                this.goToStartInterventionPage(this.intervention._id);
            },
            slotDuration(){
                return '00:30:00';
            },
            okButton(){
                this.getCalendar(this.activeStart, this.activeEnd);
                this.$modal.hide('validationModal');                
            },
            changeHandler(){
                var fin = this.pick.end.date;
                fin.setHours(parseInt(this.pick.end.hour.HH), parseInt(this.pick.end.hour.mm, 0, 0));

                var debut = this.pick.start.date;
                debut.setHours(parseInt(this.pick.start.hour.HH), parseInt(this.pick.start.hour.mm, 0, 0));

                this.planning.startTimestamp = (debut / 1000 |0);
                this.planning.endTimestamp = (fin/1000 |0);
            },
            handleDateClick(data){
                console.log(data.dateStr)
                console.log(data.resource.id)
            },
            eventClick(data){
                this.ModalType = data.event.title;

                if(this.plannings[parseInt(data.event.id)].addressStr){
                    this.ModalAddress = this.plannings[parseInt(data.event.id)].addressStr;
                }
                else{
                    this.ModalAddress = "Adresse de l'intervention inconnue"
                }
                if(this.plannings[parseInt(data.event.id)].note){
                    this.ModalNote = this.plannings[parseInt(data.event.id)].note;
                }
                else{
                    this.ModalNote = "Notes de l'intervention vide"
                }

                if(data.event.title === "divers" || data.event.title === "pause"){
                    this.isModalButton = false;
                }
                else{
                    this.isModalButton = true;
                }
                //let calendarApi = this.$refs.fullcalendar.getApi();
                //var event = calendarApi.getEventById(data.event.id);
                //var resources = event.getResources();
                //resources[0].id;
                this.getIntervention(this.id, data.event.start/1000 | 0, data.event.end/1000 | 0, data.event.title);
            },
            validateButton(){
                this.closeModalActivity();
                this.uploadActivity();
            },
            async uploadActivity(){

                var fin = this.pick.end.date;
                fin.setHours(parseInt(this.pick.end.hour.HH), parseInt(this.pick.end.hour.mm, 0, 0));
                var debut = this.pick.start.date;
                debut.setHours(parseInt(this.pick.start.hour.HH), parseInt(this.pick.start.hour.mm, 0, 0));
                this.planning.startTimestamp = debut/1000 | 0;
                this.planning.endTimestamp = fin/1000 | 0;
                
                this.planning.addressStr = this.planning.activityType;         

                var response = await axios.post('https://so.gaviota.fr/api/building/planning', {planning: this.planning});
                if(response){
                    this.validationPhrase =  "La nouvelle activitée a été correctement enregistré",
                    this.imgValidation = "/assets/right.png",
                    this.openModalValidation();                        
                }
                else{
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            plusButton(){
                this.openModalActivity();
            },
            datesRender(info){
                this.activeStart = (new Date(info.view.activeStart) /1000 | 0);
                this.activeEnd = (new Date(info.view.activeEnd) /1000 | 0);
                this.getCalendar(this.activeStart, this.activeEnd);
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('history');
                this.$cookie.delete('historyQuery');
                this.$router.replace({ name: "login" });
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                location.reload();
            },
            goToBuildingPage(){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "buildinglist"});
            },
            goToStartInterventionPage(name){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "startintervention", query:{name:name}});
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "technicien chantier" ){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getUserData();
                }
            },
            async getUserData(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/userdata/')
                if(response.data.user){
                    this.id = response.data.user.idWeweb;
                    this.planning.user.idWeweb = this.id;
                    this.title = ""+response.data.user.address.firstName;
                    this.getCalendar(this.activeStart, this.activeEnd);
                    
                    var dateNow = new Date() / 1000 | 0;
                    this.planning.startTimestamp = (dateNow - (dateNow%1800));
                    this.planning.endTimestamp = 1800 + (dateNow - (dateNow%1800));
                    

                    this.pick.start.date = new Date(this.planning.startTimestamp*1000)
                    this.pick.end.date = new Date(this.planning.endTimestamp*1000)

                    this.pick.start.hour = {
                                                HH:("0" + new Date(this.planning.startTimestamp*1000).getHours()).substr(-2),
                                                mm:("0" + new Date(this.planning.startTimestamp*1000).getMinutes()).substr(-2),
                                                ss:"00"
                                            };
                                                
                    this.pick.end.hour = {
                                                HH:("0" + new Date(this.planning.endTimestamp*1000).getHours()).substr(-2),
                                                mm:("0" + new Date(this.planning.endTimestamp*1000).getMinutes()).substr(-2),
                                                ss:"00"
                                            };
                }
            },
            async getCalendar(start, end){
                var response = await axios.get('https://so.gaviota.fr/api/building/planning/'+start+"/"+end+"/"+this.id);
                if(response.data.plannings){
                    this.plannings = response.data.plannings;
                    this.calEvents = [];
                    for(var o=0; o<this.plannings.length; o++){
                        if(this.plannings[o].isEstimated){
                            this.calEvents.push({
                                                    resourceId:this.plannings[o].user.idWeweb,
                                                    title:this.plannings[o].activityType,
                                                    start:new Date(this.plannings[o].startTimestamp*1000),
                                                    end:new Date(this.plannings[o].endTimestamp*1000),
                                                    id:o
                                                });
                        }
                        else{
                            this.calEvents.push({
                                                    resourceId:this.plannings[o].user.idWeweb,
                                                    title:this.plannings[o].activityType,
                                                    start:new Date(this.plannings[o].startTimestamp*1000),
                                                    end:new Date(this.plannings[o].endTimestamp*1000),
                                                    id:o,
                                                    color: 'purple'
                                                });
                        }
                    }         
                }
            },
            async getUserDatas(email){
                try{
                    var response = await axios.get('https://so.gaviota.fr/api/userdata/email/'+email);
                    if(response.data.user){
                        this.user = response.data.user;
                    }
                }
                catch(err){
                    this.openModal();
                }
            },
            async getInquiry(id){
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/fromintervention/'+id);
                if(response.data.inquiry){
                    this.inquiry = response.data.inquiry;
                    console.log(this.inquiry);
                    this.getBuilding(this.inquiry.name);

                }
            },
            async getBuilding(name){
                var response = await axios.get('https://so.gaviota.fr/api/building/frominquiry/'+name);
                if(response.data.building){
                    this.building = response.data.building;
                    console.log(this.building);

                    var foundPhone = false;

                    if(this.user){
                        if(this.user.address){
                            if(this.user.address.phoneNumber){
                                foundPhone = true;
                                this.ModalAddress = this.user.address.firstName+" "+
                                                    this.user.address.lastName+" - "+
                                                    this.building.buildingAddress.streetNb+" "+
                                                    this.building.buildingAddress.streetName+" "+
                                                    this.building.buildingAddress.postalCode+" "+
                                                    this.building.buildingAddress.city+" - "+
                                                    this.user.address.phoneNumber;
                            }
                        }

                    }
                    if(this.building.occupantAddress && !foundPhone){
                        if(this.building.occupantAddress.length){
                            if(this.building.occupantAddress[0].phoneNumber){
                                foundPhone = true;
                                this.ModalAddress = this.building.occupantAddress[0].firstName+" "+
                                                    this.building.occupantAddress[0].lastName+" - "+
                                                    this.building.buildingAddress.streetNb+" "+
                                                    this.building.buildingAddress.streetName+" "+
                                                    this.building.buildingAddress.postalCode+" "+
                                                    this.building.buildingAddress.city+" - "+
                                                    this.building.occupantAddress[0].phoneNumber;
                            }
                        }
                    }
                    if(this.building.ownerAddress && !foundPhone){
                        if(this.building.ownerAddress.phoneNumber){
                            foundPhone = true;
                            this.ModalAddress = this.building.ownerAddress.firstName+" "+
                                                this.building.ownerAddress.lastName+" - "+
                                                this.building.buildingAddress.streetNb+" "+
                                                this.building.buildingAddress.streetName+" "+
                                                this.building.buildingAddress.postalCode+" "+
                                                this.building.buildingAddress.city+" - "+
                                                this.building.ownerAddress.phoneNumber;
                        }                        
                    }
                    console.log(this.ModalAddress);
                }
            },
            async getIntervention(id, start, end, type){
                var response = await axios.get('https://so.gaviota.fr/api/building/intervention/planning/'+id+"/"+start+"/"+end+"/"+type);
                if(response.data.intervention){
                    this.intervention = response.data.intervention;

                    this.ModalNote = this.intervention.note;

                    if(this.intervention.emailReminder){                        
                        if(this.intervention.emailReminder.length){
                            this.getUserDatas(this.intervention.emailReminder[0])
                        }
                        else{
                            this.openModal();   
                        }
                    }
                    else{
                        this.openModal();   
                    }
                }
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';

    #techhome {
        width: 90%;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 85px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    h2{
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:11;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }
    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }
    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    #circleRed {
        width: 16px;
        height: 16px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        border-radius: 8px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: -6px;
        right: 67px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        color:white;
        text-align: center;
        font-size:13px;
        vertical-align: middle;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    #logout{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
    }
	::-webkit-scrollbar {
		width: 6px;
	}
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .calendar{
        font-family: 'BenchNine', sans-serif;
        font-size: 14px;
        margin: 40px auto;
    }
    .modalDiv{
        margin:30px;
        text-align: center;
    }
    .modalAmount{
        width:100px;
        margin:auto;
    }
    .modalTxt{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .txtDiv{
        margin-bottom: 15px; 
    }
    .modalNotes{
        background-color: #F0F0F0;
        resize: none;
        width:80%;
    }
    .docBtn3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        color: #1ce83e;
        background-color: black;
        font-size: 23px;
        padding-top:4px;
        width:32px;
        height:32px;
        position: absolute;
        border-radius:50%;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .textLen{
        width:120px;
        display: inline-block;
    }
    .inputTxt{
        width:calc(100% - (100px + 50px));
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
        background-color: #F7F7F7;
        border: 1px solid #bbb;
        padding-left:5px;
        margin-left:5px;
        display: inline-block;
    }
    .select{
        width: calc(100% - (100px + 40px));
        margin-bottom:10px;
    }
    .textline{
        padding:5px;
    }
    .wrapperDate{
        display: inline-block;
        width:calc(100% - (100px + 40px));
    }
    .area{
        resize: none;
        width: calc(100% - (100px + 50px));
    }
    .high{
        height: 100px;
        vertical-align:top;
    }
</style>
<style lang="scss" module>
    html>body>div>div>div>div>div>div>div>div>div>input{
                    width:100% !important;
                    font-family: 'BenchNine', sans-serif;
                    font-stretch: ultra-condensed;
                    font-size: 18px;
                    background-color: #F7F7F7;
                    border: 1px solid #bbb;
                    padding-left:5px;
                    margin-left:5px;
                    display: inline-block;
    }
    html>body>div>div>div>div>div>div>div>span>input{
                    width:100% !important;
                    font-family: 'BenchNine', sans-serif;
                    font-stretch: ultra-condensed;
                    font-size: 18px;
                    background-color: #F7F7F7;
                    border: 1px solid #bbb;
                    padding-left:5px;
                    margin-left:5px;
                    display: inline-block;
    }
    .wrapperDate{
        display: inline-block;
        width:calc(100% - (100px + 40px));
    }
</style>